import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import HeaderNotHome from "../Components/Header/HeaderNotHome";
import LinkComponent from "../Components/Link/Link";

function Link() {
    return (
        <>
        <HeaderNotHome />
        <LinkComponent />
        </>
      );
}

export default Link;